import React, { useContext } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { 
  ChartBarIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';
import IncompleteVisitsCard from '../components/MyVCPManagement/IncompleteVisitsCard';
import ZeroSpendCard from '../components/MyVCPManagement/ZeroSpendCard';
import PerformanceSnapshots from '../components/MyVCPManagement/PerformanceSnapshots';

function MyVCPManagement() {
  const { uinfo } = useContext(GlobalContext);

  // Check if user has access (admins for now, will refine later)
  const hasAccess = uinfo?.Status === 'admin' ||
                    uinfo?.Position?.toLowerCase().includes('director') ||
                    uinfo?.Position?.toLowerCase().includes('manager');

  if (!hasAccess) {
    return (
      <div className="min-h-screen bg-gray-50 pt-20 p-6">
        <div className="bg-white rounded-lg shadow p-6 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-indigo-100 rounded-lg">
            <ChartBarIcon className="w-6 h-6 text-indigo-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">My VCP - Management Dashboard</h1>
            <p className="text-sm text-gray-600 mt-1">Actionable insights and performance snapshots for senior management</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6 space-y-6">
        {/* Actionable Insights Section */}
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
            <ExclamationTriangleIcon className="w-5 h-5 text-orange-500" />
            <span>Actionable Insights</span>
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <IncompleteVisitsCard />
            <ZeroSpendCard />
          </div>
        </div>

        {/* Performance Snapshots Section */}
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Performance Snapshots</h2>
          <PerformanceSnapshots />
        </div>
      </div>
    </div>
  );
}

export default MyVCPManagement;

